import React from 'react';

const Search = ({ styles, searchChanged, searchTerm }) => {
  return (
    <div>
      <label
        htmlFor="search"
        style={{
          fontFamily: 'Arial',
          color: '727272'
        }}
      >
        Search
        <input
          id="search"
          type="text"
          value={searchTerm}
          onChange={searchChanged}
          style={{
            border: 0,
            borderBottom: '1px solid black',
            width: '100%',
            height: '30px',
            fontSize: '20px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            WebkitAppearance: 'none',
            ...styles
          }}
        />
      </label>
    </div>
  );
};
export default Search;
